import * as moment from 'moment-timezone';

export function setDateTime(locale) {
    return {
        'LONG_TIME': moment.localeData(locale).longDateFormat('LTS'),
        'TIME': moment.localeData(locale).longDateFormat('LT'),
        'SHORT_DATE': moment.localeData(locale).longDateFormat('L'),
        'DATE': moment.localeData(locale).longDateFormat('LL'),
        'DATE_TIME': moment.localeData(locale).longDateFormat('LLL'),
        'LONG_DATETIME': moment.localeData(locale).longDateFormat('LLLL')
    };
}

export function checkBrowserLocaleTimezone() {
    const defaults = {
        timezone: (moment.tz) ? moment.tz.guess() : 'UTC',
        language: ['en-US'],
        locale: 'en-US',
        datetime: setDateTime('en-US')
    };

    return defaults;
}

export function determineAppLanguage(appLangList: Array<string>, userLangPref: Array<string>) {
    const userLanguage = Array.isArray(userLangPref) ? userLangPref[0] : userLangPref;
    if (appLangList) {
        // if user preferred language is a supported language for the app use that language
        if (appLangList.indexOf(userLanguage) > -1) {
            return userLanguage;
        } else {
        // if user preferred language is NOT a supported language for the app, default to en-US
            return 'en-US';
        }
    } else {
        return 'en-US';
    }
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./public/app/utils/prefHelpers/prefHelpers.ts